const accountManagementStrings = {
  login: {
    emailFieldPlaceholder: 'Email',
    passwordFieldPlaceholder: 'Password',
    emailFieldValidationErrorEmpty: 'Please enter your username',
    emailFieldValidationErrorWrong: 'This email is wrong',
    passwordFieldValidationErrorEmpty: 'Please enter your password',
    loginBtn: 'Login',
    wrongCredentials: 'Email or password is wrong',
  },
};

export default accountManagementStrings;
